import dataImportApi from '../api/dataImportApi'

export default {
	async uploadActuals(plantID, fileData, confirmedContinueReferences, fileReference){
        return await dataImportApi.postUploadActuals(plantID, fileData, confirmedContinueReferences, fileReference);
    }
}